var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-inline-block overflow-hidden",staticStyle:{"background-color":"rgba(0,0,0,0.1)"}},[_c('div',{staticStyle:{"height":"70%"},style:(_vm.styleObject)})])
}
var staticRenderFns = []

export { render, staticRenderFns }